import MainShowcase from './components/MainShowcase';

function App() {
  return <MainShowcase />;
}

export default App; 